import React, { Component } from 'react';
import Routes from './route'

class App extends Component {
  render() {
    return (
      <div className="App">
        <Routes/>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js